import { IFont, FontCategory } from '../../data/fonts';

import { getAsciiText } from './ascii';

const minDigitCodePoint = 48;
const maxDigitCodePoint = 57;
const minUpperCodePoint = 65;
const maxUpperCodePoint = 90;
const minLowerCodePoint = 97;
const maxLowerCodePoint = 122;

export function fontifyChar(font: IFont | undefined, char: string) {
  const codePoint = char.codePointAt(0);

  if (codePoint >= minDigitCodePoint && codePoint <= maxDigitCodePoint) {
    return font.digits.length > 0 ? font.digits[codePoint - minDigitCodePoint] : char;
  }

  if (codePoint >= minUpperCodePoint && codePoint <= maxUpperCodePoint) {
    return font.upper[codePoint - minUpperCodePoint];
  }

  if (codePoint >= minLowerCodePoint && codePoint <= maxLowerCodePoint) {
    return font.lower[codePoint - minLowerCodePoint];
  }

  return char;
}

export function fontifyString(font: IFont, text: string) {
  if (!font) {
    return text;
  }

  if (font.mainCategory === FontCategory.TextArt) {
    return getAsciiText({ font: font.asciiFont, text });
  }

  const { transform } = font;

  if (transform) {
    return transform(text);
  }

  const len = text.length;
  let fontified = '';

  for (let i = 0; i < len; i++) {
    fontified += fontifyChar(font, text[i]);
  }

  return fontified;
}

export function fontifyAndDecorateString(font: IFont, text: string) {
  return `${font.prefix || ''}${fontifyString(font, text)}${font.suffix || ''}`;
}
